import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";

/**
 * Se usa para parsear los estilos de un string html que se va a inyectar en una vista
 * @example <div [innerHTML]="textoHtml | safeHtml"></div>
 */
@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(html): any {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

}
